import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { languageOptions, dictionaryList } from "./index";
import { getPersonalizedLanguageConfig } from "@/apis/apiCollection";
import tabIcon from '@/assets/images/favicon.svg'
import { useGlobalState } from "@/GlobalProvider";
import { AuthContext } from "@/auths/Auth";
import { downloadFileLink } from "@/apis/announcementApi";


const makeLangConfCache = () => Object.fromEntries(Object.keys(languageOptions).map(lang => ([lang, {}])))
const personalizedLangCache = {}
window.test = personalizedLangCache
let personalizedLangFetch = Object.fromEntries(Object.keys(languageOptions).map(lang => ([lang, null])))
// it provides the language context to app
export const LanguageProvider = ({ children, noLangConf }) => {
  const {canLoadLangConf} = useContext(AuthContext)
  const { currentCompanyId } = useGlobalState()
  if (!personalizedLangCache[currentCompanyId]) personalizedLangCache[currentCompanyId] = makeLangConfCache()
  const [userLanguage, setUserLanguage] = useState(
    localStorage.getItem("rcml-lang") || "en"
  );
  const [langConf, setLangConf] = useState(personalizedLangCache[currentCompanyId][userLanguage])

  const fetchData = () => {
    let lang = localStorage.getItem("rcml-lang");
    /**
     * To prevent error about someday someone to change lang name e.g. 'zh_tw' => 'tw', and user still have old rcml-lang value 'zh_tw' in browser indexDB,
     * so give it below conditional expressions to see if now includes this value, if not give it to default value 'en'
     * By Dylan
     * */
    if (!Object.keys(dictionaryList).includes(lang)) {
      localStorage.setItem("rcml-lang", "en");
      setUserLanguage("en");
    } else {
      setUserLanguage(lang || "en");
    }
  };

  const provider = {
    userLanguage,
    dictionary: dictionaryList[userLanguage],
    langConf,
    userLanguageChange: selected => {
      const newLanguage = languageOptions[selected] ? selected : "en";
      setUserLanguage(newLanguage);
      localStorage.setItem("rcml-lang", newLanguage);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.__langDictionary = dictionaryList[userLanguage];
    window.__userLanguage = userLanguage;
  }, [userLanguage]);

  useEffect(() => {
    if (noLangConf) return
    // 第一次登陆，token和companyId都没有准备好，需要等Auth结束
    // 登陆后，后续再打开无所谓
    if (!canLoadLangConf) return
    const personalizedLanguageConfig = personalizedLangCache[currentCompanyId][userLanguage]
    if (personalizedLanguageConfig.lang) {
      setLangConf(personalizedLanguageConfig)
    } else {
      personalizedLangFetch[userLanguage] = getPersonalizedLanguageConfig({ lang: userLanguage }).then(
        langConf => {
          const config = !langConf.lang ? {} : {
            deviceCenter: JSON.parse(langConf.deviceCenter),
            deviceCenterTab: JSON.parse(langConf.deviceCenterTab),
            platform: JSON.parse(langConf.platform),
            platformTab: JSON.parse(langConf.platformTab),
            supportCenter: JSON.parse(langConf.supportCenter),
            nubisDrive: JSON.parse(langConf.nubisDrive),
            lang: userLanguage
          }
          personalizedLangCache[currentCompanyId][userLanguage] = config
          setLangConf(config)
        },
        () => {
          setLangConf({})
          personalizedLangCache[currentCompanyId][userLanguage] = {}
        }
      )
    }
  }, [userLanguage, currentCompanyId, canLoadLangConf])

  useEffect(() => {
    if (noLangConf) return
    if (langConf.deviceCenterTab?.icon) {
      downloadFileLink(langConf.deviceCenterTab.icon).then(res => setTabIcon(res.download_link))
    } else {
      setTabIcon(tabIcon)
    }
    if (langConf.deviceCenterTab?.text) {
      document.title = langConf.deviceCenterTab.text;
    } else {
      document.title = "Device Center"
    }
  }, [langConf])

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  );
};

function setTabIcon(iconUrl) {
  const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = iconUrl
    } else {
      const newLink = document.createElement('link')
      newLink.rel = 'icon';
      newLink.href = iconUrl
      document.head.appendChild(newLink);
    }
}